import { FC } from 'react';
import MenuItem from './menu-item';
import { IconType } from '../../icon/helpers';
import useCopyWithToast from '@/hooks/use-copy-with-toast.hook';

interface Props {
  value: string;
  label: string;
  icon: IconType;
}

const CopyMenuItem: FC<Props> = ({ value, label, icon }) => {
  const copy = useCopyWithToast();
  return <MenuItem label={label} icon={icon} onClick={() => copy(value)} />;
};

export default CopyMenuItem;
